import { useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useUserStore from '../../store/user';

export default function ProtectedRoutes() {
  const user = useUserStore(state => state.user);
  const isInitialized = useUserStore(state => state.isInitialized);
  const checkSession = useUserStore(state => state.checkSession);
  const location = useLocation();

  useEffect(() => {
    if (!isInitialized) {
      checkSession();
    }
  }, [isInitialized, checkSession]);

  // Show loading while checking session
  if (!isInitialized) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <Spinner animation="border" />
      </div>
    );
  }

  // Only redirect if session check is complete and no user
  if (!user) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
